$(() => {
  const duration = 300;
  const pricingTableSection = $('.pricing-table');
  const pricingTableHeader = pricingTableSection.find('.pricing-table-header');
  const pricingTableDescription = pricingTableSection.find('.pricing-table-description');

  if (pricingTableSection.length === 0) {
    return;
  }
  const toggleScrolledClass = () => {
    const adminBarHeight = $('#wpadminbar').length > 0 ? $('#wpadminbar').height() : 0;
    const headerHeight = $('header').height() + adminBarHeight;

    const stickyPricingTableHeaderOffset = pricingTableHeader.offset().top - headerHeight;
    const descriptionHideOffset = pricingTableHeader.offset().top - 300;
    const scrollTop = $(window).scrollTop();

    if (scrollTop >= stickyPricingTableHeaderOffset) {
      pricingTableHeader.addClass('sticky-table-header');
    } else {
      pricingTableHeader.removeClass('sticky-table-header');
    }

    if (scrollTop >= descriptionHideOffset) {
      pricingTableDescription.slideUp(duration);
    }
    else {
      pricingTableDescription.slideDown(duration);
    }
  };

  $(window).on('load scroll', () => {
    toggleScrolledClass();
  });
});
